import React from 'react';
import { ConversationUserMessage } from 'src/pages/ConversationsPage/ConversationChat/ConversationUserMessage/ConversationUserMessage';
import { ConversationAIMessage } from 'src/pages/ConversationsPage/ConversationChat/ConversationAIMessage/ConversationAIMessage';
import { ConversationResolvedMessage } from 'src/pages/ConversationsPage/ConversationChat/ConversationResolvedMessage/ConversationResolvedMessage';
import { ConversationEscalatedMessage } from 'src/pages/ConversationsPage/ConversationChat/ConversationEscalatedMessage/ConversationEscalatedMessage';
import { EmptyChatIcon } from 'src/pages/ConversationsPage/ConversationChat/EmptyChatIcon';

const LAST_MESSAGE = {
  RESOLVED: 'End of the chat.',
  ESCALATED: 'Connected to the operator. Please, wait a moment.',
};

const filterMessage = (message) => {
  if (message.body.includes(LAST_MESSAGE.RESOLVED)) {
    return false;
  }
  if (message.body.includes(LAST_MESSAGE.ESCALATED)) {
    return false;
  }

  return true;
};

export const ConversationChat = ({ chat }) => {
  const is: Record<string, any> = {
    resolved: ['closed', 'auto_closed'].includes(chat.status),
    escalated: chat.status === 'escalated',
  };

  return chat.messages.length ? (
    <ul className={'flex flex-col gap-[5px] h-[100%] pr-[15px] overflow-auto'}>
      {chat.messages.filter(filterMessage).map((message, index, arr) => {
        is.user = message.owner === 'user';
        is.lastMessage = index === arr.length - 1;

        return is.user ? (
          <ConversationUserMessage
            key={`message-${message._id}`}
            message={message}
            chat={chat}
            isLastMessage={is.lastMessage}
          />
        ) : (
          <ConversationAIMessage
            key={`message-${message._id}`}
            message={message}
            chat={chat}
            isLastMessage={is.lastMessage}
          />
        );
      })}
      {is.resolved && <ConversationResolvedMessage date={chat.updated_at} />}
      {is.escalated && <ConversationEscalatedMessage date={chat.updated_at} />}
    </ul>
  ) : (
    <div className={'w-full h-full flex flex-col items-center justify-center'}>
      <EmptyChatIcon />
    </div>
  );
};
